export default {

    /**
     * Lương hiện thời
     */
    KPTL_LHT: "KPTL_LHT",

    /**
     * Nâng lương
     */
    KPTL_NL: "KPTL_NL",

    /**
     * Phụ cấp thâm niên vượt khung
     */
    KPTL_NPCTNVK: "KPTL_NPCTNVK",

    /**
     * Phụ cấp thâm niên nghề
     */
    KPTL_NPCTNN: "KPTL_NPCTNN",

    /**
     * Cải cách tiền lương
     */
    KPTL_CCTL: "KPTL_CCTL",

    /**
     * Nâng lương thâm niên nghề năm hiện hành (SGD Điện Biên)
     */
    SGDDB_NTNN: "SGDDB_NTNN",
}
